import { ChangeDetectorRef ,ViewRef,Component, EventEmitter, Input, OnInit, Output,HostListener } from '@angular/core'
import { Stringable, StringableValues } from '../../../../common/stringable.decorator'
import { MessageDialogComponent } from './dialog/message-dialog.component'
import { JSONRpcResponse } from '../../../../Interfaces/JSONRpcResponse'
import { DialogService, StateService,DossierService,
		CommunicationService
 } from '../../../../services'


import {
	Observable,
	BehaviorSubject,	
} from "rxjs";

const KEY = 'message'

@Component({
  selector: 'atyl-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
@Stringable({
  path: 'views/partials/content/general/message',
  key: KEY,
})
export class MessageComponent implements OnInit {

  @Input() loading:BehaviorSubject<boolean>=new BehaviorSubject<boolean>(false);
  @Input() load: boolean=true;
  
  @StringableValues(KEY) strings: any
  
  @Input() dossier: any;
  @Input() type: string='courrier';
  @Input() id: any;
  @Input() button: boolean=false;
  
  @Input() object: any;
  
  points:any[]=[];
  messages:any[]=[];

  @Output() change = new EventEmitter<any>();
  private sub: any[]=[];
  
  constructor(
    private changeDetector: ChangeDetectorRef,
    private stateService: StateService,
    private dialogService: DialogService,
    private dossierService: DossierService,
    private changeDetectorRef: ChangeDetectorRef,
    private communicationService: CommunicationService
  ) { }

  ngOnInit() {
	  
	 this.sub.push( 
		this.loading.subscribe((loading:boolean)=>{
		console.log("MessageComponent loading",loading,this.load)
		if (loading && !this.load) {
					this._loadMessagePOint(); 
				
				}
		 })
	  );
	 	
     
    
  }
  
  ngAfterViewInit() {
	if (this.load)
		this._loadMessagePOint(); 
  }
  
  ngOnDestroy() {
	 this.sub.forEach( (sb: any) => {;
    	sb.unsubscribe();
	})
  }
  
   _loadMessagePOint() {
		let _opts:any={
				object: this.object
		   }
		   this.points=[];
		   this.messages=[];
		   this.sub.push(    
		   this.communicationService.getMessagePointList(this.id,this.type,_opts).subscribe(
			   (res: JSONRpcResponse) => {
					console.log("MessageComponent loaded",res);
					let r:any= {
						points: this.points,
						messages: this.messages
					}
					if (res.result 
						&& res.result!=undefined
						&& res.result.points!=undefined
						&& res.result.messages!=undefined
					) {
						this.points=res.result.points;
						this.messages=res.result.messages;
						this.detectChanges();
						
						r=res.result;
					} 
					
					this.change.emit(r);	
				}
		   )
		   );
	
	
   }
  
   detectChanges() {
        setTimeout(() => {
            if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
                this.changeDetectorRef.detectChanges()
            }
        })
    }
	
	@HostListener("click") onClick(event:any){
	    console.log("User Click using Host Listener")
		this.message(event);
	}
	
   	
	message(event:any) {
		
		if (this.points.length>0) {
			   const dialogRef = this.dialogService.open(MessageDialogComponent, {
		            data: {
						id: this.id,
		                object: this.object,
		                dossier: this.dossier,
		                points: this.points,
						type: this.type,
		            },
		            draggable: false,
		            resizable: false,
		            height: '60vh',
					width: "60vw",
		        })
		        
		         dialogRef.afterClosed().subscribe(result => {
					this._loadMessagePOint(); 
		        });
			}
		  
	   }
  

}
